
module.exports = {
  address: '0xA0A2eE912CAF7921eaAbC866c6ef6FEc8f7E90A4',
  address_test: '0xafa4c15125f71f2a10cebcc8c4f125e66169d09f',
  abi: require('./DPR.abi.json')
}
